import moment from "moment";
import * as requestFromServer from "./dashboardConsorcioCrud";
import { dashboardConsorcioSlice, callTypes } from "./dashboardConsorcioSlice";

const { actions } = dashboardConsorcioSlice;

export const fetchBigNumbers = ({ filter }) => dispatch => {
  console.log(filter, "filterfilter")
  const {
    mesReferencia,
    cpfCnpj,
    endereco,
    idUC,
    nomeTitular
  } = filter;
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .fetchBigNumbers({
      mesReferencia: moment(mesReferencia).format("YYYY-MM-01"),
      cpfCnpj,
      endereco,
      idUC,
      nomeTitular,
    })
    .then(response => {
      const bigNumbers = response.data.entities.resultado;
      dispatch(actions.fetchBigNumbers({ bigNumbers }))
    })
}

export const fetchBigNumbersUltimoMes = ({ filter }) => dispatch => {
  const {
    mesReferencia,
    cpfCnpj,
    endereco,
    idUC,
    nomeTitular
  } = filter;
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .fetchBigNumbers({
      mesReferencia: moment(mesReferencia).subtract(1, "months").format("YYYY-MM-01"),
      cpfCnpj,
      endereco,
      idUC,
      nomeTitular,
    })
    .then(response => {
      const bigNumbersUltimoMes = response.data.entities.resultado;
      dispatch(actions.fetchBigNumbersUltimoMes({ bigNumbersUltimoMes }))
    })
}

export const fetchGraficoCompararEconomia = ({ filter }) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .fetchGraficoCompararEconomia(filter)
    .then(response => {
      const grafico = response.data.entities.resultado.grafico;
      dispatch(actions.fetchGraficoCompararEconomia({ grafico }));
    })
}

export const fetchHistoricoEconomia = ({ filter }) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .fetchHistoricoEconomia(filter)
    .then(response => {
      const historicoEconomia = response.data.entities.resultado;
      dispatch(actions.fetchHistoricoEconomia({ historicoEconomia }));
    })
}

export const fetchConsorcios = (idCliente) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .fetchConsorcios(idCliente)
    .then(response => {
      const consorcios = response.data.entities.resultado;
      dispatch(actions.fetchConsorcios({ consorcios }));
    })
}

export const fetchHistoricoFaturas = (filter) => dispatch => {
  dispatch(actions.startCall({ calltype: callTypes.list }));
  return requestFromServer
    .fetchHistoricoFaturas(filter)
    .then(response => {
      const { totalCount, entities } = response.data;
      dispatch(actions.fetchHistoricoFaturas({ totalCount, entities }));
    })
    .catch(error => {
      error = "Can't find Histórico de Faturas";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchNotificacoesLead = (filter) => dispatch => {
  dispatch(actions.startCall({ calltype: callTypes.list }));
  return requestFromServer
    .fetchNotificacoesLead(filter)
    .then(response => {
      const { entities } = response.data;
      dispatch(actions.fetchNotificacoesLead({ entities }));
    })
    .catch(error => {
      error = "Can't find Histórico de Faturas";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const setFiltroDashboardConsorcio = filter => dispatch => {
  const filtroStorage = JSON.parse(localStorage.getItem("filtro.DashboardConsorcio"));

  const newFiltroStorage = Object.assign(filtroStorage, { filter });
  localStorage.setItem("filtro.DashboardConsorcio", JSON.stringify(newFiltroStorage));

  dispatch(actions.dashboardConsorcioFiltro({ dashboardConsorcioFiltro: newFiltroStorage }));
}

export const setPaginationDashboardConsorcio = ({ page, sizePerPage, sortField, sortOrder }) => dispatch => {
  const pageNumber = page || 1;

  const filtroStorage = JSON.parse(localStorage.getItem("filtro.DashboardConsorcio"));

  const newFiltroStorage = Object.assign({ ...filtroStorage, pageNumber, pageSize: sizePerPage, sortField, sortOrder });
  localStorage.setItem("filtro.DashboardConsorcio", JSON.stringify(newFiltroStorage));

  dispatch(actions.setFiltroDashboardConsorcio({ dashboardConsorcioFiltro: newFiltroStorage }));
}


export const fetchFaturasDownload = (id) => async dispatch => {
  dispatch(actions.startCall({ calltype: callTypes.list }));
  
  try {
    const response = await requestFromServer.fetchFaturasDownload(id);
console.log(response, "DATA")
    const blob = new Blob([response.data], { type: 'application/zip' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'arquivo.zip'); // Nome do arquivo
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);

    // Se houver outras ações a serem realizadas, coloque-as aqui
  } catch (error) {
    const errorMessage = "Can't find Histórico de Faturas";
    dispatch(actions.catchError({ error: errorMessage, callType: callTypes.list }));
  }
};